import { INVESTMENT } from "network/endpoints";
import ewbApi from "network/ewbApi";

export const fetchInvestmentLandingPage = async () =>
  ewbApi.get(INVESTMENT.investmentLandingPage);

export const fetchInvestmentProductDetails = async (id: String) =>
  ewbApi.get(`${INVESTMENT.investementProductDetails}/${id}`);
